export const categories = [
  {
    slug: "jingxuan-tuijian",
    name: "精选推荐",
    description: "编辑团队精心甄选的优质内容，涵盖各领域最值得关注的精华文章",
    icon: "ri-star-line",
    color: "accent",
  },
  {
    slug: "shendu-pingce",
    name: "深度评测",
    description: "专业视角深度解析，从多维度为你呈现最真实的产品与内容评估",
    icon: "ri-file-search-line",
    color: "primary",
  },
  {
    slug: "dujia-faxian",
    name: "独家发现",
    description: "挖掘不为人知的优质资源与创意，带你发现世界另一端的美好",
    icon: "ri-compass-3-line",
    color: "secondary",
  },
  {
    slug: "pinzhi-shenghuo",
    name: "品质生活",
    description: "探索有温度的生活方式，从日常细节中汲取品质灵感",
    icon: "ri-heart-line",
    color: "accent",
  },
  {
    slug: "keji-shuma",
    name: "科技数码",
    description: "前沿科技资讯与数码产品解读，让你始终站在时代前沿",
    icon: "ri-smartphone-line",
    color: "primary",
  },
  {
    slug: "wenhua-yuedu",
    name: "文化阅读",
    description: "深度阅读与人文思考，在文字中感受思想的力量",
    icon: "ri-book-open-line",
    color: "secondary",
  },
];